import { FC } from 'react';

import { HStack, VStack } from '@ui-furniture/elements';
import { x } from '@ui-furniture/style';

import { ChatMenu } from './chat-menu';

import { ChatState } from '../types/chat-state';

export const ChatLayout: FC<
  {
    messages: JSX.Element;
    input: JSX.Element;
    setIsEditing: (cb: (is: boolean) => boolean) => void;
    isEditing: boolean;
  } & Pick<ChatState['internalState'], 'isEditing' | 'setIsEditing' | 'undo'>
> = ({ messages, input, isEditing, setIsEditing, undo }) => (
  <VStack flex={1} overflow='hidden' w='100%'>
    <x.div
      flex={1}
      display='flex'
      alignItems='stretch'
      justifyContent='stretch'
      overflowY='hidden'
      position='relative'
    >
      {messages}
      <ChatMenu undo={undo} isEditing={isEditing} setIsEditing={setIsEditing} />
    </x.div>
    <HStack flex={0}>
      <x.div flex='1'>{input}</x.div>
    </HStack>
  </VStack>
);
